import { BaseFilterProps, Filter, FilterData } from "@/components/filter/_types";
import { FilterComponent } from "@/components/filter/base-filter";
import { JSX } from "react";

export class OpenPositionDunningLevelFilter extends Filter<Record<string, never>, Record<string, never>> {
  private readonly dunningLevels = [0, 1, 2, 3, 4];

  readonly id = "dunningLevel";
  readonly labelSingular = "fia:FilterDunningLevel";
  readonly labelPlural = "fia:FilterDunningLevel";
  readonly placeholder = "fia:FilterDunningLevel";
  readonly searchPlaceholder = "common:Search";
  readonly emptyText = "fia:NoOptionFound";
  body = {};
  parameters = {};

  getData(): FilterData {
    return {
      options: this.dunningLevels.map((level) => ({ id: String(level), name: String(level) })),
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps): JSX.Element {
    return <FilterComponent filter={this} {...props} />;
  }
}
